function padIbge(raw) {
  const d = String(raw ?? "").replace(/\D+/g, "");
  if (!d) return "";
  return d.padStart(7, "0");
}

/**
 * Compara cidades da planilha de concessões com a cerca virtual (vencedor por município).
 */
export function diffConcession({ sheetRows = [], coveragePoints = [], dealerMap = {}, districtMap = {} }) {
  const byIbge = new Map();
  for (const p of coveragePoints || []) {
    const ibge = padIbge(p.ibge);
    if (!ibge) continue;
    byIbge.set(ibge, p);
  }

  const brandMismatch = [];
  const branchMismatch = [];
  const missingCoverage = [];
  const unmappedDealer = [];
  const seenSheet = new Set();

  for (const row of sheetRows) {
    const ibge = padIbge(row.ibge);
    if (!ibge) continue;
    seenSheet.add(ibge);
    const region = dealerMap[row.dealer] || "";
    const target = districtMap[row.district] || "";
    if (!region) {
      unmappedDealer.push(row);
      continue;
    }
    const point = byIbge.get(ibge);
    if (!point || !point.winner) {
      missingCoverage.push({
        ...row,
        expectedRegion: region,
        expectedTarget: target,
      });
      continue;
    }
    const gotRegion = point.winner.region_key || "";
    const gotTarget = point.winner.target_cod_interno || "";
    if (gotRegion !== region) {
      brandMismatch.push({
        ...row,
        expectedRegion: region,
        expectedTarget: target,
        actualRegion: gotRegion,
        actualTarget: gotTarget,
        cityCadastro: point.city,
      });
      continue;
    }
    if (target && gotTarget && gotTarget !== target) {
      branchMismatch.push({
        ...row,
        expectedRegion: region,
        expectedTarget: target,
        actualRegion: gotRegion,
        actualTarget: gotTarget,
        cityCadastro: point.city,
      });
    }
  }

  const extraCoverage = [];
  for (const p of coveragePoints || []) {
    const ibge = padIbge(p.ibge);
    if (!ibge || seenSheet.has(ibge)) continue;
    extraCoverage.push({
      ibge,
      city: p.city,
      uf: p.uf,
      actualRegion: p.winner?.region_key || "",
      actualTarget: p.winner?.target_cod_interno || "",
    });
  }

  const unmappedDealerNames = [...new Set(unmappedDealer.map((r) => r.dealer))].sort((a, b) =>
    a.localeCompare(b, "pt")
  );

  return {
    brandMismatch,
    branchMismatch,
    missingCoverage,
    extraCoverage,
    unmappedDealerCount: unmappedDealer.length,
    unmappedDealerNames,
    summary: {
      sheet: sheetRows.length,
      coverage: coveragePoints.length,
      brandMismatch: brandMismatch.length,
      branchMismatch: branchMismatch.length,
      missingCoverage: missingCoverage.length,
      extraCoverage: extraCoverage.length,
      unmappedDealer: unmappedDealer.length,
    },
  };
}

export function concessionDiffToCsv(diff) {
  const lines = [["tipo", "ibge", "cidade", "uf", "planilha_marca", "planilha_filial", "cadastro_marca", "cadastro_destino"]];
  const push = (tipo, r) => {
    lines.push([
      tipo,
      r.ibge || "",
      r.city || r.cityCadastro || "",
      r.uf || "",
      r.dealer || r.expectedRegion || "",
      r.district || r.expectedTarget || "",
      r.actualRegion || "",
      r.actualTarget || "",
    ]);
  };
  for (const r of diff.brandMismatch || []) push("marca_diferente", r);
  for (const r of diff.branchMismatch || []) push("destino_diferente", r);
  for (const r of diff.missingCoverage || []) push("sem_cerca", r);
  for (const r of diff.extraCoverage || []) push("cerca_sem_planilha", r);
  return lines
    .map((row) => row.map((c) => `"${String(c).replace(/"/g, '""')}"`).join(";"))
    .join("\n");
}
